import React from "react";
import { statusStyle, prettify } from "@/lib/format";

export const StatusBadge = ({ value, label, testid }) => {
  if (value === undefined || value === null || value === "") return <span className="text-muted-foreground">—</span>;
  const s = statusStyle(value);
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border whitespace-nowrap"
      style={{ backgroundColor: s.bg, color: s.color, borderColor: s.border }}
    >
      {label || prettify(value)}
    </span>
  );
};
